import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "renderRow", "renderList", "location"];
import I18n from 'I18n';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import UICopyButton from 'UIComponents/button/UICopyButton';
import { COURSE_OVERVIEW_URL_FRAGMENT, LESSON_OVERVIEW_URL_FRAGMENT } from '../../../constants/Navigation';
import { buildReferralLink, getPlaylistUrl } from '../../../utils/RoutingUtils';
import UsageTracker from '../../../utils/UsageTracker';
import { useUserInfo } from '../../accounts';
import { useUserOwnsPlaylist } from '../../savedItems';
import UIList from 'UIComponents/list/UIList';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { getShortContentUrl } from '../../shortContent/shortContentRouting';
import { useSocialShareData } from '..';
import { getShareLinks } from 'academy-common-lib/utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const useReferalLink = ({
  lessonId,
  trackId,
  playlistId,
  shortId,
  language
}) => {
  const {
    userInfo
  } = useUserInfo();
  const userId = Number(userInfo && userInfo.user.id);
  if (playlistId) {
    return buildReferralLink(getPlaylistUrl(playlistId), userId);
  } else if (lessonId) {
    return buildReferralLink(`${LESSON_OVERVIEW_URL_FRAGMENT}/${lessonId}${language ? `/${language}` : null}`, userId);
  } else if (trackId) {
    return buildReferralLink(`${COURSE_OVERVIEW_URL_FRAGMENT}/${trackId}${language ? `/${language}` : null}`, userId);
  } else if (shortId && language) {
    return buildReferralLink(getShortContentUrl({
      shortId,
      language
    }).fullUrl, userId);
  }
  return null;
};
const useShareLink = props => {
  const link = useReferalLink(props);
  const {
    template: referalTemplate
  } = useSocialShareData(props);
  const template = referalTemplate ? `${referalTemplate}: ` : '';
  return Object.assign({
    link
  }, getShareLinks(link || '', template));
};
export const SocialShareList = _ref => {
  let {
      onClick,
      renderRow = button => button,
      renderList = content => /*#__PURE__*/_jsx(UIList, {
        children: content
      }),
      location
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const userIsOwner = useUserOwnsPlaylist(props.playlistId);
  const {
    link,
    linkForX,
    linkForFacebook,
    linkForWhatsapp,
    linkForLinkedIn
  } = useShareLink(props);
  const handleOnClick = shareType => {
    UsageTracker.track('interaction', Object.assign({
      action: 'social-share',
      isOwner: userIsOwner,
      location,
      to: shareType
    }, props));
    if (onClick) onClick(shareType);
  };
  return renderList( /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderRow( /*#__PURE__*/_jsx(UICopyButton, {
      onClick: () => {
        FloatingAlertStore.addAlert({
          type: 'success',
          message: I18n.text('learningCenter.shareThis.notification')
        });
        handleOnClick('link');
      },
      style: {
        width: '100%'
      },
      tooltipPlacement: "right",
      use: "unstyled",
      value: link,
      children: /*#__PURE__*/_jsxs(UILink, {
        use: "unstyled",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "copy",
          size: "small"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.socialShare.copyLink"
        })]
      })
    })), renderRow( /*#__PURE__*/_jsxs(UILink, {
      href: linkForX,
      onClick: () => handleOnClick('x'),
      target: "_blank",
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "socialX",
        size: "small"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.socialShare.shareX"
      })]
    })), renderRow( /*#__PURE__*/_jsxs(UILink, {
      href: linkForFacebook,
      onClick: () => handleOnClick('facebook'),
      target: "_blank",
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "socialFacebook",
        size: 24,
        style: {
          width: 16,
          transform: 'translateX(-5px)',
          marginRight: 7
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.socialShare.shareFacebook"
      })]
    })), renderRow( /*#__PURE__*/_jsxs(UILink, {
      href: linkForLinkedIn,
      onClick: () => handleOnClick('linkedin'),
      target: "_blank",
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "socialLinkedin",
        size: "small"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.socialShare.shareLinkedIn"
      })]
    })), renderRow( /*#__PURE__*/_jsxs(UILink, {
      href: linkForWhatsapp,
      onClick: () => handleOnClick('whatsapp'),
      target: "_blank",
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "socialWhatsapp",
        size: "small"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.socialShare.shareWhatsApp"
      })]
    }))]
  }));
};
export default SocialShareList;